export const FACULTY_1_CONSTANTS = {
    DEFAULT_ROW: {
      id: "1",
      meta_desktop_image: "",
      meta_mobile_image: "",
      meta_name: "Faculty Member",
      meta_designation: "Designation",
      meta_designation_text_color: "#666666",
      meta_alt_image: "Faculty",
      meta_priority: 0,
      meta_status: true,
    },
  
    FACULTY_FIELDS_CONFIG: [
      {
        fieldName: "title",
        label: "Title",
        value: "",
        valueType: "string",
        filedType: "INPUT",
        placeholder: "Enter Title",
        required: false,
        defaultValue: "Our Faculty",
      },
      {
        fieldName: "title_text_color",
        label: "Title Text Color",
        value: "#000000",
        valueType: "string",
        filedType: "COLOR",
        placeholder: "Enter title text color (e.g., #000000)",
        required: false,
        defaultValue: "#000000",
      },
      {
        fieldName: "left_navigation_icon",
        label: "Left Navigation Icon",
        value: "",
        valueType: "string",
        filedType: "FILE",
        placeholder: "Upload Left Navigation Icon",
        required: false,
        defaultValue: "",
      },
      {
        fieldName: "left_navigation_icon_alt",
        label: "Left Navigation Icon Alt Text",
        value: "",
        valueType: "string",
        filedType: "INPUT",
        placeholder: "Enter alt text for left navigation icon",
        required: false,
        defaultValue: "Left navigation",
      },
      {
        fieldName: "right_navigation_icon",
        label: "Right Navigation Icon",
        value: "",
        valueType: "string",
        filedType: "FILE",
        placeholder: "Upload Right Navigation Icon",
        required: false,
        defaultValue: "",
      },
      {
        fieldName: "right_navigation_icon_alt",
        label: "Right Navigation Icon Alt Text",
        value: "",
        valueType: "string",
        filedType: "INPUT",
        placeholder: "Enter alt text for right navigation icon",
        required: false,
        defaultValue: "Right navigation",
      },
      {
        fieldName: "description",
        label: "Description",
        value: "",
        valueType: "string",
        filedType: "TEXT_AREA",
        placeholder: "Enter Description",
        required: false,
        defaultValue: "",
      },
      {
        fieldName: "description_text_color",
        label: "Description Text Color",
        value: "#000000",
        valueType: "string",
        filedType: "COLOR",
        placeholder: "Enter description text color (e.g., #000000)",
        required: false,
        defaultValue: "#000000",
      },
      {
        fieldName: "description_background_color",
        label: "Description Background Color",
        value: "#ffffff",
        valueType: "string",
        filedType: "COLOR",
        placeholder: "Enter description background color (e.g., #ffffff)",
        required: false,
        defaultValue: "#ffffff",
      },
      {
        fieldName: "status",
        label: "Status",
        value: false,
        valueType: "boolean",
        filedType: "TOGGLE",
        placeholder: "Enter Status",
        defaultValue: false,
      }
    ],
  
    METADATA_FIELDS: [
      {
        header: "Desktop Image",
        fieldName: "meta_desktop_image",
        value: "",
        valueType: "string",
        filedType: "FILE",
        placeholder: "Upload Desktop Image",
      },
      {
        header: "Mobile Image",
        fieldName: "meta_mobile_image",
        value: "",
        valueType: "string",
        filedType: "FILE",
        placeholder: "Upload Mobile Image",
      },
      {
        header: "Name",
        fieldName: "meta_name",
        value: "",
        valueType: "string",
        filedType: "INPUT",
        placeholder: "Enter Name",
      },
      {
        header: "Name Text Color",
        fieldName: "meta_name_text_color",
        value: "#000000",
        valueType: "string",
        filedType: "COLOR",
        placeholder: "Enter name text color (e.g., #000000)",
      },
      {
        header: "Name Section Background Color",
        fieldName: "meta_name_background_color",
        value: "#ffffff",
        valueType: "string",
        filedType: "COLOR",
        placeholder: "Enter name section background color (e.g., #ffffff)",
      },
      {
        header: "Designation",
        fieldName: "meta_designation",
        value: "",
        valueType: "string",
        filedType: "TEXT_AREA",
        placeholder: "Enter Designation",
      },
      {
        header: "Designation Text Color",
        fieldName: "meta_designation_text_color",
        value: "#666666",
        valueType: "string",
        filedType: "COLOR",
        placeholder: "Enter designation text color (e.g., #666666)",
      },
      {
        header: "Alt Image",
        fieldName: "meta_alt_image",
        value: "",
        valueType: "string",
        filedType: "INPUT",
        placeholder: "Enter Alt Image Text",
      },
      {
        header: "Priority",
        fieldName: "meta_priority",
        value: "",
        valueType: "number",
        filedType: "INPUT",
        placeholder: "Enter Priority",
        required: true,
      },
      {
        header: "Status",
        fieldName: "meta_status",
        value: "",
        valueType: "boolean",
        filedType: "TOGGLE",
        placeholder: "Enter Status",
      },
    ]
  };